import axios from '@/api/axios';

export const getExport = (exportId: string) => axios.get(`/exports/${exportId}`);
export const getImport = (importId: string) => axios.get(`/imports/${importId}`);
